import { useEffect } from 'react';
import { useRoutes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { CssBaseline, ThemeProvider } from '@material-ui/core';
import SplashScreen from './views/shared/SplashScreen';
import useAuth from './hooks/useAuth';
import useScrollReset from './hooks/useScrollReset';
import routes from './routes';
import { createCustomTheme } from './theme';
import './App.css';
import yandexMetrika from './lib/yandexMetrika';
import WarningDialog from './components/common/WarningDialog';
import CacheBuster from 'react-cache-buster';
import packageJson from '../package.json';
import { useTranslation } from 'react-i18next';

const App = () => {
  const content = useRoutes(routes);
  const auth = useAuth();
  // eslint-disable-next-line no-unused-vars
  const { t, i18n } = useTranslation();

  useScrollReset();

  useEffect(() => {
    yandexMetrika.init();
  }, []);

  const settings = {
    compact: true,
    direction: 'ltr',
    responsiveFontSizes: true,
    roundedCorners: true,
    theme: auth.theme
  };

  const theme = createCustomTheme({
    direction: settings.direction,
    responsiveFontSizes: settings.responsiveFontSizes,
    roundedCorners: settings.roundedCorners,
    theme: settings.theme,
  });

  const isProduction = process.env.NODE_ENV === 'production';

  return (
    <CacheBuster
      currentVersion={packageJson.version}
      isEnabled={isProduction}
      isVerboseMode={false}
      loadingComponent={<SplashScreen />}
      metaFileDirectory="."
    >
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Toaster
          position="top-center"
          toastOptions={{
            duration: 10 * 1000,
            error: {
              duration: 15 * 1000,
            }
          }}
        />
        <WarningDialog />
        {auth.isInitialized ? content : <SplashScreen />}
      </ThemeProvider>
    </CacheBuster>
  );
};

export default App;
